<template>
  <div class="dropdown dropdown-news-action ">
    <button class="btn-outline btn btn-xs btn-info dropdown-toggle" :id="'dropdownMenu-news'+news.id"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      <i class="pe-7s-more pe-1x fa-rotate-90"></i>
    </button>
    <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right">
      <template v-if="news.biblio !== true">
        <li><a role="button" @click="dropDownClick('addNewsToBiblio', news, $event)"><i
        class="fa fa-plus text-success"></i> Save to Biblio</a></li>
      </template>

      <template v-if="news.url">
        <li>
          <a role="button" :href="news.url" target="_blank">
            <i class="fa fa-eye text-success"></i> View news
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['value', 'context'],
  name: 'DropdownNews',
  data () {
    return {
      news: null
    }
  },
  watch: {
    value: function (value) {
      this.news = value
    },
    news: function (val) {
      this.$emit('input', this.news)
    }
  },
  methods: {
    dropDownClick: function (action, news, event) {
      switch (action) {
        case 'addNewsToBiblio':
          let doc = this.convertToDocument(news)
          this.context.addDocumentToBiblio(doc)
          break
      }

      $('#dropdownMenu-news' + news.id).dropdown('toggle')

      event.stopPropagation()
    },
    convertToDocument: function (news) {
      return {
        documentID: news.hashId,
        pubDate: news.datePublished,
        title: news.name,
        publication: news.provider[0].name,
        link: news.url,
        type: 'news',
        co_authors: [],
        abstract: news.description,
        doi: null
      }
    }
  },
  beforeMount () {
    this.news = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DropdownNews.vue